			import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class TimeZoneService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('TimeZone');
	}
	
	loadAll() : Observable<any[]> {
		return this.myBaseService.loadAll(this.url);
	}
}
	
			